"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A callback function to handle missing tags.
 * @callback MissingPathCallback
 * @param {string} path - The path that was not found.
 * @param {string} tag - The tag that was not found.
 * @returns {string} The tag that was not found.
 */
var defaultMissingPathHandler = function (path, tag) {
    return tag;
};
exports.default = defaultMissingPathHandler;
